// Registration PIN step: hand-off between the end of registration and the
// standalone /register-set-pin route.
//
// The marker is set at the very end of a successful registration and consumed by
// whichever screen finishes the auth flow (MFA setup, or the auto-login for
// programs without MFA). It is deliberately single-use: once consumed the user
// is on the PIN screen, and the Galileo round trip comes back through an
// explicit callback URL rather than relying on this flag.

export const PIN_SETUP_PENDING_KEY = 'pin_setup_pending';

export const PIN_SETUP_PATH = '/register-set-pin';

export const markPinSetupPending = () => {
  try {
    sessionStorage.setItem(PIN_SETUP_PENDING_KEY, '1');
  } catch (e) {
    // Private mode / blocked storage: the PIN step is optional, so losing the
    // marker just means the cardholder lands on the dashboard instead.
  }
};

export const clearPinSetupPending = () => {
  try {
    sessionStorage.removeItem(PIN_SETUP_PENDING_KEY);
  } catch (e) {
    // no-op, see markPinSetupPending
  }
};

// Reads and clears the marker in one go.
export const consumePinSetupPending = () => {
  try {
    const pending = sessionStorage.getItem(PIN_SETUP_PENDING_KEY) === '1';
    if (pending) clearPinSetupPending();
    return pending;
  } catch (e) {
    return false;
  }
};

// Where to send the cardholder once every auth factor is done.
export const destinationAfterAuth = () =>
  (consumePinSetupPending() ? PIN_SETUP_PATH : '/');
